enum Variant {
  signUp = 'signUp',
  signIn = 'signIn',
  loggedIn = 'loggedIn',
  forgotPassword = 'forgotPassword',
}

export { Variant };
